import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const teamH2HSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.TEAM_H2H_MATCH_SELECTOR}`,
        popover: {
            title: "Match Filter",
            description:
                "Click either team's card to open a match picker where you can select a specific subset of games. " +
                "By default all matches are included; narrow the selection to focus on recent form, home games, or any custom range.",
            side: "bottom",
            align: "center",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAM_H2H_LINES}`,
        popover: {
            title: "Line-by-Line Averages",
            description:
                "Each line (1–4) is shown as a pair of cards — one per team — displaying average KPI scores for " +
                "Defensive, Offensive, Team Play, Effort, Bonus, and Total for the selected matches. " +
                "Click any line row to expand it and reveal the individual player breakdown table for both teams.",
            side: "right",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.TEAM_H2H_CHARTS}`,
        popover: {
            title: "Line Performance Over Time",
            description:
                "Two side-by-side line charts track the total KPI of each line across every match in the tournament. " +
                "Toggle individual lines on or off to focus on the matchup that matters most.",
            side: "top",
            align: "center",
        },
    },
];
